export default {
  props: {
    itemData: {
      type: Object,
      required: true
    },
    formData: {
      // 表单数据对象
      type: Object,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // item() {
    //   return this.controlData;
    // }
  },
  data() {
    return {};
  },
  created() {
    // console.log(this.formData);
  },
  methods: {
    blurFun() {
      this.$emit('valueChange', this.itemData.mark);
    }
  }
};